export enum DeleteType {
  DELETE = 'delete',
  MOVE = 'move',
}
